import React from "react";
import { useLocation } from "react-router-dom";

import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ChurchProfileUpdateChild from "./ChurchProfileUpdateChild";

const ChurchProfileUpdate = () => {
  const { state } = useLocation();
  const churchid = state?.church_id;

  console.log(state);
  return (
    <MainTemplate>
      <CardBackground>
        <ChurchProfileUpdateChild church_id={churchid} />
      </CardBackground>
    </MainTemplate>
  );
};

export default ChurchProfileUpdate;
